<template>
  <div class="pa-5">
    <v-form v-model="inviteMailValid" ref="emailForm">
      <div>{{ $t('InviteChatForm.InviteEmail') }}</div>
      <v-text-field v-model="mail" :rules="rules.email" outlined type="text" name="Mail" style="background-color: white; margin-left: 13px" />
      <div>
        <v-btn :disabled="!inviteMailValid" :loading="buttonLoading" style="border-radius: 10px" class="elevation-0 btn-invite" color="primary" @click="inviteChat(1)">
          {{ $t('InviteChatForm.Send MAIL') }}
        </v-btn>
      </div>
    </v-form>

    <v-form v-model="invitePhoneValid" ref="phoneForm">
      <div>{{ $t('InviteChatForm.InvitePhone') }}</div>
      <v-text-field v-model="phone" :rules="rules.phone" outlined type="text" name="Phone" style="background-color: white; margin-left: 13px" />
      <div>
        <v-btn :disabled="!invitePhoneValid" :loading="buttonLoading" style="border-radius: 10px" class="elevation-0 btn-invite" color="primary" @click="inviteChat(3)">
          {{ $t('InviteChatForm.Send SMS') }}
        </v-btn>
        <v-btn :disabled="!invitePhoneValid" :loading="buttonLoading" style="border-radius: 10px" class="elevation-0 btn-invite" color="primary" @click="inviteChat(2)">
          {{ $t('InviteChatForm.Send Whatsapp') }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";

export default {
    name: "InviteChatForm",
    props: {
        propMail: {
            type: String,
            required: false,
            default: ""
        },
        propPhone: {
            type: String,
            required: false,
            default: ""
        }
    },
    data () {
        return {
            buttonLoading: false,
            invitePhoneValid: false,
            inviteMailValid: false,
            phone: "",
            mail: "",
            rules: {
                phone: [ v => (/^(\+?[\d ]{9,}|)$/.test(v) && v !== "") || this.$t('The phone must be valid') ],
                email: [ v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.') ],
            }
        };
    },
    watch: {
        propMail: function () {
            this.$refs.emailForm.reset();
            this.mail = this.propMail;
        },
        propPhone: function () {
            this.$refs.phoneForm.reset();
            this.phone = this.propPhone;
        },
    },
    created () {
        this.mail = this.propMail;
        this.phone = this.propPhone;
    },
    activated: function () {
        this.$nextTick(() => {
            console.log("activated")
        })
    },
    methods: {
        inviteChat (inviteMethod) {
            this.buttonLoading = false;
            this.$emit('invite', {inviteMethod, phone: this.phone, mail: this.mail});
        },

    }
};
</script>

<style scoped>
.btn-invite{
    margin: 0 10px 10px 13px;
}
</style>
